import { showModal, hideModals } from '@/utils/modal';

class ModalScript {
    modalShowAttrName = 'data-modal-show';
    modalHideAttrName = 'data-modal-hide';
    constructor() {
        this.cacheProps();
        this.bindEvents();
    }
    cacheProps() {
        this.modalElems = document.querySelectorAll('.modal');
        this.modalOpenTriggerElems = document.querySelectorAll(`[${this.modalShowAttrName}]`);
        this.modalCloseTriggerElems = document.querySelectorAll(`[${this.modalHideAttrName}]`);
    }
    bindEvents() {
        this.modalOpenTriggerElems.forEach((elem) =>
            elem.addEventListener('click', this.handleModalOpenTriggerClick.bind(this))
        );
        this.modalCloseTriggerElems.forEach((elem) =>
            elem.addEventListener('click', this.handleModalCloseTriggerClick.bind(this))
        );
    }
    handleModalOpenTriggerClick(e) {
        const modalId = e.target.getAttribute(this.modalShowAttrName);
        showModal(modalId, this.modalElems);
    }
    handleModalCloseTriggerClick(e) {
        hideModals(this.modalElems);
    }
}

new ModalScript();

export default ModalScript
